import { useMemo } from 'react';
import { TextField, Stack, FormHelperText } from '@mui/material';
import { useFormikContext } from 'formik';
import { get, isArray } from 'lodash';

// Components
import { IPropsDataPeopleContribute } from 'src/features/PeopleDetail/Common/config';

const SocialMediaPeople = ({ indexData }: { indexData: number }) => {
  const { values, handleChange, handleBlur, errors, touched } = useFormikContext<IPropsDataPeopleContribute>();
  const errorsObject = useMemo(() => {
    if (isArray(errors.contribution_social_media_people_profile)) {
      return { website: get(errors.contribution_social_media_people_profile?.[indexData], 'website', '') };
    }

    return {
      website: '',
    };
  }, [errors, touched]);
  return (
    <Stack spacing={0.5} flex={1}>
      <TextField
        required
        id={`contribution_social_media_people_profile[${indexData}].website`}
        name={`contribution_social_media_people_profile[${indexData}].website`}
        value={get(values.contribution_social_media_people_profile, `[${indexData}].website`, '')}
        onChange={handleChange}
        onBlur={handleBlur}
        size="small"
        fullWidth
        error={Boolean(touched.contribution_social_media_people_profile?.[indexData]?.website && errorsObject?.website)}
        label={<span>Website Company (URL)</span>}
      />
      {touched.contribution_social_media_people_profile?.[indexData]?.website && (
        <FormHelperText error>{errorsObject?.website}</FormHelperText>
      )}
    </Stack>
  );
};

export default SocialMediaPeople;
